export function langChange(langList) {
    const langMap = {
        en: "en-US",
        TW: "zh-HK",
        HK: "zh-HK",
        zh: "zh-CN",
        ar: "ar-AE",
        pl: "pl-PL",
        fa: "fa",
        da: "da-DK",
        de: "de-AT",
        ru: "ru-RU",
        fr: "fr-FR",
        nl: "nl-NL",
        cs: "cs-CZ",
        ro: "ro",
        pt: "pt-BR",
        ja: "ja-JP",
        th: "th-TH",
        tr: "tr-TR",
        el: "el-GR",
        it: "it-IT",
        vi: "vi",
        hi: "hi-IN",
        es: "es-ES",
        ko: "ko-KR",
        id: "id-ID",
        ms: "ms-MY",

        // 下面是你列表里新增的缺失项
        bn: "bn",      // 孟加拉语
        he: "he",      // 希伯来语
        uk: "uk",      // 乌克兰语
        km: "km",      // 高棉语
        sk: "sk",      // 斯洛伐克语
        hu: "hu",      // 匈牙利语
        sl: "sl",      // 斯洛文尼亚语
        bg: "bg",      // 保加利亚语
        hr: "hr"       // 克罗地亚语
    };


    for (const langCode of langList) {
        const lowerCode = langCode.toLowerCase();
        for (const key in langMap) {
            if (lowerCode.includes(key)) {
                return langMap[key];
            }
        }
    }
    return "en-US"; // 默认值
}